module.exports = __webpack_public_path__ + "media/yi_er_san_song_level3.5b7d9ef4.mp3";